// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2cDH9","sendOtp":"AuthorizeToLogin_sendOtp__2T6Zr"};